export default __webpack_public_path__ + "static/media/device-online-24px.bc4ea825.svg";